import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3553 1.58594L22.1468 4.37737L12.3773 14.1469L9.58582 11.3555L19.3553 1.58594Z",
			fill: "#94A3B8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.14286 12.0002L8.07143 14.5002L7 17.0002L12 14.8573L9.14286 12.0002Z",
			fill: "#94A3B8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 9.00015V20.0002H4V4.00015H15V2.00015H4C2.89543 2.00015 2 2.89558 2 4.00015V20.0002C2 21.1047 2.89543 22.0002 4 22.0002H20C21.1046 22.0002 22 21.1047 22 20.0002V9.00015H20Z",
			fill: "#94A3B8"
		})
	]
});
export default SvgLine;
